import {UcoastEl} from "@/scripts/core/UcoastEl"
import { TsDOM as q } from '@/scripts/core/TsDOM'
import {MediaGallery} from "@/scripts/product/media-gallery";

export class MainProduct extends UcoastEl {
  static htmlSelector = 'main-product'

  colors: undefined | NodeListOf<HTMLElement>
  mediaGallery?: MediaGallery
  optionCount: number

  constructor() {
    super()

    this.colors = q.ol('[data-uc-product-variant-color]', this)
    this.mediaGallery = q.os('media-gallery', this)
    this.optionCount = parseInt(q.ra(this, 'data-option-count'))


    if (this.colors && this.colors.length) {
      this.colors.forEach(color => color.addEventListener('click', this.switch.bind(this)))
      this.colors[0].click()
    }
  }

  // todo: this has been replaced but will still run if no specific images are chosen - remove this code as soon as all product galleries have been converted away from the *cough* illegal alt text method
  switch(event: Event) {
    if (!this.mediaGallery) return
    if (this.mediaGallery.customVariantMedia) return // exit early if accessible variant media is available
    if (this.optionCount > 1) return // this straight up never worked for more than one option so dont run it lol
    const {value} = event.target

    const images = q.rl('img', this.mediaGallery)

    let nth = null

    for (const index in images) {
      const image = images[index]

      if (image.tagName !== 'IMG') continue
      const alt = image.getAttribute('alt')
      if (!alt) continue
      image.closest('li').classList.toggle('hidden', alt !== value)

      if (alt === value && nth === null) {
        nth = +index
      }
    }

    this.mediaGallery.elements.viewer.slider.scrollTo({left: 0})
  }
}
